import { render, staticRenderFns } from "./AccordionElectrical.vue?vue&type=template&id=21cd48be"
import script from "./AccordionElectrical.vue?vue&type=script&lang=js"
export * from "./AccordionElectrical.vue?vue&type=script&lang=js"
import style0 from "./AccordionElectrical.vue?vue&type=style&index=0&id=21cd48be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports